import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_layout-app/app/settings/subscription')({
  validateSearch: (search: Record<string, unknown>) => ({
    resume_subscription:
      typeof search.resume_subscription === 'string'
        ? search.resume_subscription
        : undefined,
    checkout_success:
      typeof search.checkout_success === 'string'
        ? search.checkout_success
        : undefined,
    checkout_canceled:
      typeof search.checkout_canceled === 'string'
        ? search.checkout_canceled
        : undefined,
    checkout_session_id:
      typeof search.checkout_session_id === 'string'
        ? search.checkout_session_id
        : undefined,
    billing_updated:
      typeof search.billing_updated === 'string'
        ? search.billing_updated
        : undefined,
    plan:
      search.plan === 'monthly' || search.plan === 'annual'
        ? search.plan
        : undefined,
  }),
});
